<template>
  <fragment>
    <scrollactive v-if="isDesktop" :offset="navOffset" active-class="active" tag="div">
      <v-btn
        v-for="(item, index) in menuPrimary"
        :key="index"
        class="anchor-link scrollactive-item"
        text
        @click="setOffset(item.offset)"
        v-bind="item.external ? {
          href: item.link,
          target: '_blank',
          rel: 'noopener noreferrer'
        } : {
          to: localePath(item.link),
          exact: true
        }"
      >{{ $t('header.' + item.name) }}</v-btn>
    </scrollactive>
  </fragment>
</template>

<style lang="scss" scoped>
@import "../header-style.scss";
</style>

<script>
export default {
  data() {
    return {
      navOffset: 20,
      hover: false
    };
  },
  methods: {
    setOffset: function(offset) {
      this.navOffset = offset;
    }
  },
  computed: {
    isDesktop() {
      const lgUp = this.$store.state.breakpoints.lgUp;
      return lgUp.indexOf(this.$mq) > -1;
    }
  },
  props: {
    menuPrimary: {
      type: Array,
      required: true
    }
  }
};
</script>
